import { Api } from '../fetch';

export const inventoryGeneralNet = {
  getQboItems: () => Api.get<'inventory', 'qboItems'>('/inventory/quickbooks/items'),
  sync: (lastSync: Date = new Date(0)) => Api.get<'inventory', 'sync'>('/inventory/sync', { query: { lastSync } }),
  getAdjustments: (
    categoryId: string,
    date: { lastSync: Date } | { olderThan: Date },
    { skip, take }: { skip?: number; take?: number } = {},
  ) =>
    Api.get<'inventory', 'getAdjustments'>('/inventory/adjustments', {
      query: {
        categoryId,
        lastSync: 'lastSync' in date ? date?.lastSync : undefined,
        olderThan: 'olderThan' in date ? date?.olderThan : undefined,
        skip,
        take,
      },
    }),
  listAllAdjustments: ({ skip, take }: { skip?: number; take?: number } = {}) =>
    Api.get<'inventory', 'listAllAdjustments'>('/inventory/adjustments/all', { query: { skip, take } }),
};
